import React from 'react';
import { Box } from '@mui/material';

const InnerContainer = ({ children }) => {
  return (
    <Box
      sx={{
        width: '99%',
        height: '99%',
        display: 'flex',
        backgroundColor: '#F6FAFF',
        borderRadius: '15px',
        boxShadow: 2,
        overflow: 'hidden',
      }}>
      {children}
    </Box>
  );
};

export default InnerContainer;